import Drawer from '~/js/utils/drawer';

export default ((node) => {
  const FilterDrawer = Drawer(node, true);
  const drawerTriggers = [...document.querySelectorAll('[data-drawer-trigger="filter"]')];

  // Listen to drawer-triggers
  if (drawerTriggers.length) {
    drawerTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => FilterDrawer.toggle());
    });
  }
});
